import { styled, Typography } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import Modal, { Content } from 'components/Modal';

export const StyledModal = styled(Modal)`
  .MuiDialog-container > .MuiPaper-root {
    padding: 2rem;
    ${theme.breakpoints.down('sm')} {
      width: 90%;
    }
  }

  .MuiButton-root {
    position: absolute;
    top: 0px;

    svg {
      color: ${theme.palette.primary.main};
    }
  }
`;

export const StyledContent = styled(Content)`
  display: flex;
  align-items: center;
  flex-direction: column;

  &.MuiCardContent-root {
    min-width: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

export const Text = styled(Typography)`
  margin-top: 1.5rem;
  font-weight: 800;
  text-align: center;
`;
